import { render } from "./Child.vue?vue&type=template&id=31be6433"
const script = {}

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/components/Child.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31be6433"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31be6433', __exports__)) {
    api.reload('31be6433', __exports__)
  }
  
  module.hot.accept("./Child.vue?vue&type=template&id=31be6433", () => {
    api.rerender('31be6433', render)
  })

}


export default __exports__